import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  projectId: 'flowcore-st-mirror',
  appId: '1:366271653896:web:bc47b18221ce00e62809bd',
  storageBucket: 'flowcore-st-mirror.firebasestorage.app',
  apiKey: 'AIzaSyD2ofbMh-CDYG5Nx_3fPD3juGP_1pTnnsA',
  authDomain: 'flowcore-st-mirror.firebaseapp.com',
  messagingSenderId: '366271653896',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ hd: 'flowcorewater.com' });
